<template>

  <iframe :src="gameFrameUrl"></iframe>

</template>

<script>


export default {
  props: {
    id: '',
    languageId: '',
    isDemo: false
  },
  components: {},
  data() {
    return {
      completed: false
    };
  },
  computed: {
    gameFrameUrl() {
      let result = process.env.VUE_APP_GAME_TETRIS_URL;

      let queryString = "id=" + this.id;

      if (this.$route.query.language) {
        queryString += "&language=" + this.$route.query.language.toUpperCase();
      }


      let base64 = btoa(queryString);
      //console.log(base64);

      result += "?e=" + process.env.VUE_APP_API_ENV + "&data=" + Math.random().toString(36).substring(2, 7) + base64;

      //console.log(result);

      return result;
    }
  },
  methods: {
    onComplete: function (event) {

      this.completed = true;
      // `this` inside methods points to the Vue instance
      this.$emit('end');
    },
    onStart: function (event) {
      this.$emit('start');
    },
  }
};
</script>

<style scoped>

iframe {
  position: fixed;
  background: #000;
  border: none;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>